import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Curriculum from "./pages/Curriculum";
import Assessment from "./pages/Assessment";
import Dashboard from "./pages/Dashboard";
import Lesson from "./pages/Lesson";
import Pricing from "./pages/Pricing";
import PaymentSuccess from "./pages/PaymentSuccess";
import Speaker from "./pages/Speaker";
import Admin from "./pages/Admin";
import Certificate from "./pages/Certificate";
import { Toaster } from "./components/ui/sonner";

const Protected = ({ children, admin }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null) return <div className="py-32 text-center text-[#8A857D]">Loading...</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

function Shell() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FDFBF7]">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/curriculum" element={<Curriculum />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/speaker" element={<Speaker />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/lesson/:pillarId/:lessonId" element={<Protected><Lesson /></Protected>} />
          <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
          <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
          <Route path="/certificate/:token" element={<Certificate />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}
